import { FormActionFrameworkStep, registerStep } from '../step';
import { resolveTemplate } from '../template';
import { findSurveyQuestion, resolveFieldName } from './populateDropdown';
export class SetFormValueStep extends FormActionFrameworkStep {
    constructor() {
        super(...arguments);
        Object.defineProperty(this, "type", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: 'setFormValue'
        });
        Object.defineProperty(this, "config", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: {
                fieldName: '',
                value: '',
            }
        });
    }
    async execute(context) {
        const fieldName = resolveFieldName({
            fieldName: String(resolveTemplate(this.config.fieldName ?? '', context) ?? ''),
        });
        if (!fieldName) {
            context.log('[setFormValue] missing fieldName — skipped');
            return context;
        }
        const resolved = resolveTemplate(this.config.value ?? '', context);
        const model = context.form;
        if (!model) {
            context.log('[setFormValue] no form model on context — skipped');
            return context;
        }
        const question = findSurveyQuestion(model, fieldName);
        if (question) {
            question.value = resolved;
        }
        else if (typeof model.setValue === 'function') {
            model.setValue(fieldName, resolved);
        }
        else {
            context.log(`[setFormValue] question not found for fieldName="${fieldName}" — skipped`);
            return context;
        }
        // Keep context.formValues in sync for later steps in the same milestone.
        context.formValues = {
            ...context.formValues,
            ...(model.data && typeof model.data === 'object' ? model.data : {}),
            [fieldName]: resolved,
        };
        context.log(`[setFormValue] ${fieldName} = ${summarize(resolved)}`);
        return context;
    }
    showStepForm(container, _context, onUpdated) {
        const cfg = this.config;
        container.innerHTML = `
      <div class="mb-3">
        <label class="form-label">Step name</label>
        <input type="text" class="form-control" data-faf="name" value="${escapeAttr(this.name)}" />
      </div>
      <div class="mb-3">
        <label class="form-label">Field name (SurveyJS name / data-name)</label>
        <input type="text" class="form-control" data-faf="fieldName" value="${escapeAttr(cfg.fieldName)}" placeholder="surveyjs_data_name" />
      </div>
      <div class="mb-3">
        <label class="form-label">Value</label>
        <textarea class="form-control" data-faf="value" rows="3" placeholder="literal or {{variable}}">${escapeText(String(cfg.value ?? ''))}</textarea>
        <div class="text-muted small">Supports {{ }} expressions against context variables.</div>
      </div>
    `;
        const sync = () => {
            this.name = inputValue(container, 'name');
            this.config.fieldName = inputValue(container, 'fieldName');
            this.config.value = textareaValue(container, 'value');
            onUpdated?.();
        };
        container.querySelectorAll('input, textarea').forEach((el) => {
            el.addEventListener('change', sync);
            el.addEventListener('blur', sync);
        });
    }
}
function summarize(value) {
    if (value == null)
        return String(value);
    if (typeof value === 'object') {
        try {
            const json = JSON.stringify(value);
            return json.length > 120 ? `${json.slice(0, 117)}...` : json;
        }
        catch {
            return '[object]';
        }
    }
    return String(value);
}
function inputValue(container, key) {
    const el = container.querySelector(`[data-faf="${key}"]`);
    return el?.value?.trim() ?? '';
}
function textareaValue(container, key) {
    const el = container.querySelector(`[data-faf="${key}"]`);
    return el?.value ?? '';
}
function escapeAttr(value) {
    if (value == null)
        return '';
    return String(value)
        .replace(/&/g, '&amp;')
        .replace(/"/g, '&quot;')
        .replace(/</g, '&lt;');
}
function escapeText(value) {
    return value.replace(/&/g, '&amp;').replace(/</g, '&lt;');
}
registerStep('setFormValue', SetFormValueStep);
